import { useId } from "react";

/** Official Metazik logo mark — two notes forming an "M", pink-to-blue
 * gradient. Inline SVG (not an <img>) so it stays crisp at any size and
 * never needs a separate network request. Gradient ids are namespaced per
 * instance (useId) so multiple logos on the same page never collide. */
export default function MetazikIcon({ className = "w-6 h-6" }) {
  const uid = useId();
  const g = `mzg-${uid}`;
  return (
    <svg viewBox="-134 -46 1270 1270" className={className} aria-hidden="true">
      <defs>
        <linearGradient id={g} gradientUnits="userSpaceOnUse" x1="60" y1="0" x2="940" y2="0">
          <stop offset="0" stopColor="#ff1650" />
          <stop offset="0.28" stopColor="#ff1f6e" />
          <stop offset="0.55" stopColor="#c93fd6" />
          <stop offset="0.78" stopColor="#8f4df2" />
          <stop offset="1" stopColor="#1b8fff" />
        </linearGradient>
      </defs>
      <g fill="none" stroke={`url(#${g})`} strokeWidth="108" strokeLinecap="round" strokeLinejoin="round">
        <path d="M275 965 V135 L578 345 L880 135 V727" />
      </g>
      <g fill={`url(#${g})`}>
        <circle cx="197" cy="965" r="132" />
        <circle cx="815" cy="727" r="122" />
      </g>
      <g strokeLinecap="round" fill="none">
        <path d="M383 945 V962" stroke="#ff2a6a" strokeWidth="46" />
        <path d="M473 885 V1005" stroke="#f0287f" strokeWidth="46" />
        <path d="M575 805 V1070" stroke="#c43fd8" strokeWidth="50" />
        <path d="M672 890 V1005" stroke="#8f4df2" strokeWidth="46" />
        <path d="M768 935 V960" stroke="#1b8fff" strokeWidth="42" />
      </g>
    </svg>
  );
}
